@if ((loaded$ | async) == true) {
  <div class="bankamount">
    @if (sBankamount.showComponent) {
      <div class = "bankColum">
        <div class="bankamountRow">
          <div class="left">
            @if (sBankamount.textAmount) {
              <span class="mat-headline-2" data-testid="title" [innerHTML]="sBankamount.textAmount"></span>
            }
            @if (!sBankamount.textAmount) {
              <span class="mat-headline-2" data-testid="title" [innerHTML]="TRANSLATE_PATH.BANKAMOUNT_TITLE | translate"></span>
            }
          </div>
          <div class="right">
            <span class="mat-headline-2" color="primary" data-testid="amount" [innerHTML]="(sBankamount.amount | number : '1.2-2' : 'de-DE')+' &#8364;'"></span>
          </div>
        </div>
        <div>
          <mat-divider></mat-divider>
        </div>
      </div>
    }
  </div>
}